import { Button, Grid } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import { FilterBuilder, groupSlotsByDate, renderSlots, type Filters } from '../DateAndTime.helpers';
import Location from '../Location';
import { NearByV4Response } from '@src/lib/__generated/api';
import { useFacilityStore } from '@src/store';
const THREE_DAYS = 3;
export default function NearbySlots({
  nearbySlots,
  filters,
  date
}: Readonly<{
  nearbySlots: NearByV4Response;
  filters: Filters;
  date: Date;
}>) {
  const setFacility = useFacilityStore(store => store.setFacility);
  const {
    t
  } = useTranslation('dateAndTime');
  const filteredNearbySlots = useMemo(() => groupSlotsByDate(FilterBuilder.addData(nearbySlots.timeslots ?? []).filterByDayOfWeek(filters.weekDays).filterByTimeOfDay(filters.timeOfDay).filterByDaysAfterDate(date).build()), [nearbySlots.timeslots, filters.timeOfDay, filters.weekDays, date]);
  return <>
			{filteredNearbySlots && Object.keys(filteredNearbySlots).length > 0 ? <Location location={nearbySlots}>
					{renderSlots(filteredNearbySlots, THREE_DAYS, nearbySlots, filters)}
					<Grid container justifyContent="center">
						<Button data-test-id="view-all-times-button" variant="tertiaryDefault" size="M" onClick={() => setFacility(nearbySlots)}>
							{t('allTimes')}
						</Button>
					</Grid>
				</Location> : null}
		</>;
}